export const instants : number[] = [
/*    10349,
    2234,
    1959,
    6505,
    5443,
    1570*/
];
